export const siteInfo = {
  name: '008pg国际',
  tagline: '安全正版 · 极速下载 · 畅享精彩',
  description: '008pg国际官方下载平台，提供安全正版的008pg国际App安装包，支持iOS和Android双平台。官方认证渠道，保障您的账户安全与数据隐私。',
  domain: 'https://008pg.com',
  downloadLinks: {
    ios: 'https://apps.apple.com/app/008pg',
    android: 'https://play.google.com/store/apps/008pg',
  },
};

export const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '官方认证渠道',
    description: '通过官方认证的安全下载通道，杜绝恶意软件与病毒侵害，全方位保障您的设备与账户安全。',
  },
  {
    id: 2,
    icon: 'ri-rocket-2-line',
    title: '极速流畅体验',
    description: '采用先进的性能优化技术，确保应用运行流畅稳定，无论网络环境如何都能享受极致体验。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '双平台全覆盖',
    description: '完美兼容iOS与Android系统，定期同步更新，让不同设备的用户都能第一时间体验最新版本。',
  },
  {
    id: 4,
    icon: 'ri-lock-line',
    title: '数据安全加密',
    description: '采用银行级别的数据加密技术，严格保护用户隐私信息，让每一次使用都安心无忧。',
  },
  {
    id: 5,
    icon: 'ri-customer-service-2-line',
    title: '7×24小时客服',
    description: '专业客服团队全天候在线，快速响应您的问题与需求，提供贴心周到的一对一服务支持。',
  },
  {
    id: 6,
    icon: 'ri-refresh-line',
    title: '持续版本更新',
    description: '研发团队持续优化产品体验，定期推送功能更新与安全补丁，始终保持行业领先水准。',
  },
];

export const downloadSteps = [
  {
    step: 1,
    title: '选择您的设备平台',
    description: '根据您使用的手机系统，点击对应的iOS或Android下载按钮，进入官方下载页面。',
    icon: 'ri-smartphone-line',
  },
  {
    step: 2,
    title: '点击下载安装包',
    description: '在官方下载页面中，点击"立即下载"按钮，系统将自动开始下载最新版本的安装包文件。',
    icon: 'ri-download-cloud-2-line',
  },
  {
    step: 3,
    title: '完成安装与注册',
    description: '下载完成后按照提示完成安装，打开应用注册或登录您的008pg国际账户，即可开始体验。',
    icon: 'ri-user-add-line',
  },
];

export const stats = [
  { label: '全球用户', value: '500万+', icon: 'ri-user-line' },
  { label: '覆盖国家', value: '80+', icon: 'ri-global-line' },
  { label: '安全运行天数', value: '1800+', icon: 'ri-shield-check-line' },
  { label: '好评率', value: '98.5%', icon: 'ri-heart-line' },
];

export const faqItems = [
  {
    question: '008pg国际App是否免费下载？',
    answer: '是的，008pg国际App完全免费下载。您可以通过官方网站或官方应用商店免费获取最新版本的安装包，无需支付任何下载费用。',
  },
  {
    question: 'iOS和Android版本功能是否一致？',
    answer: '两个平台的核心功能完全一致，我们都保持同步更新。由于系统特性差异，部分交互细节可能略有不同，但整体使用体验和功能完整性是完全相同的。',
  },
  {
    question: '如何确认下载的是正版安装包？',
    answer: '请务必通过008pg国际官方网站或官方认证的应用商店渠道下载。正版安装包具有官方数字签名，下载页面地址以官方域名为准。请勿通过第三方网站或不明链接下载，以免下载到恶意篡改的版本。',
  },
  {
    question: '安装后无法打开怎么办？',
    answer: '首先请确认您的设备系统版本符合最低要求（iOS 12+或Android 8+）。如仍无法打开，请尝试清除应用缓存或重新安装。若问题持续，请联系我们的在线客服获取技术支持。',
  },
  {
    question: '账户安全如何保障？',
    answer: '008pg国际平台采用多重安全防护机制，包括SSL加密传输、双因素认证、异常登录检测等技术手段。建议您设置强密码并开启二次验证，进一步提升账户安全性。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '您可以通过App内的"在线客服"功能、官方网站的联系表单、或发送邮件至我们的官方客服邮箱获取帮助。我们的客服团队7×24小时全天候为您服务。',
  },
];